<template>
  <div class="tab-panel">
    <ul class="directories">
      <li v-for="(item, index) in directories" :key="index" @click="gotoDetail(item.id)">
        <p>
          {{item.title}}
        </p>
        <img :src="item.img" alt="" />
      </li>
    </ul>
  </div>
</template>

<script>
import { getNewsList } from "@/api/news.js";
import { delHtmlTag } from "@/utils/index.js";
import moment from "moment";
export default {
  data() {
    return {
      directories: [],
    };
  },
  methods: {
    delHtmlTag,
    moment,
    getList(){
      getNewsList({
        categorys: '名录',
        pageIndex: 1,
        pageSize: 6,
      }).then(res=>{
        this.directories = res.data.list;
      });
    },
    gotoDetail(id) {
      this.$router.push(`/news/newsDetail?id=${id}`);
    },
  },
  mounted(){ 
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.tab-panel {
  width: 100%;
}
@media screen and (min-width: 961px) {
  .directories {
    background-color: #f8f8f8;
    padding: 0 20px;
    margin-top: 30px;
    box-sizing: border-box;
    // min-height: 600px;
    li {
      padding: 20px 14px;
      font-size: 18px;
      color: #222;
      border-bottom: 1px dotted #ccc;
      display: flex;
      align-items: center;
      p {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        flex: 1;
      }
      img {
        height: 48px;
        vertical-align: middle;
        text-align: right;
        border-radius: 6px;
      }
    }
  }
}
@media screen and (max-width: 960px) {
  .directories {
    margin-top: 0.16rem;
    box-sizing: border-box;
    li {
      &::before {
        content: "·";
      }
      padding: 0.12rem 0.1rem;
      font-size: 0.14rem;
      font-weight: 400;
      color: #333333;
      line-height: 0.22rem;
      display: flex;
      border-radius: 0.08rem;
      &:nth-child(2n + 1) {
        background-color: #f9f9f9;
      }
      &:nth-child(2n) {
        background-color: #fff;
      }
      p {
        font-size: 0.14rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.22rem;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      img {
        width: 0.47rem;
        height: 0.36rem;
        vertical-align: middle;
        border-radius: 0.04rem;
      }
    }
  }
}
</style>